import React, { useState } from "react";
import { sendHtmlEmail } from "../emailapi";
const ContactSection = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const html = `
      <h2>New Contact Enquiry</h2>
      <p><strong>Name:</strong> ${formData.name}</p>
      <p><strong>Email:</strong> ${formData.email}</p>
      <p><strong>Subject:</strong> ${formData.subject}</p>
      <p><strong>Phone:</strong> ${formData.phone}</p>
      <p><strong>Message:</strong> ${formData.message}</p>
    `;
    try {
      await sendHtmlEmail(
        "info@ashamodernschool.com",
        "New Website Enquiry",
        html
      );
      alert("Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        subject: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      alert("Failed to send message.");
    }
    setLoading(false);
  };
  return (
    <section className="relative py-20 px-4 md:px-8 bg-gradient-to-br from-blue-50 via-red-50 to-blue-50 w-full overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-200/30 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-200/30 rounded-full blur-3xl translate-x-48 translate-y-48"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex px-5 py-2 bg-white rounded-full shadow-md mb-4">
            <span className="text-sm font-semibold text-red-600">
              Get In Touch
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900">
            Contact{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Us
            </span>
          </h2>
          <p className="text-gray-600 mt-3 max-w-2xl mx-auto text-sm md:text-base">
            We'd love to hear from you. Reach out for enquiries or school visit.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl shadow-xl border border-orange-100">
            <div className="p-6 md:p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Interested in discussing?
              </h3>
              <p className="text-gray-500 text-sm mb-6">
                Fill the form below and we'll get back to you soon.
              </p>
              <form className="space-y-4" onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter Full Name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your Email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Enter Subject"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                />
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter Number"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                />
                <textarea
                  rows="4"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter Message"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg resize-none"
                ></textarea>
                <div className="space-y-3">
                  <label className="flex items-start gap-3 text-sm text-gray-600">
                    <input
                      type="checkbox"
                      required
                      className="mt-1 accent-red-600"
                    />
                    <span>
                      I agree to the Terms & Conditions and Privacy Policy.
                    </span>
                  </label>

                  <label className="flex items-start gap-3 text-sm text-gray-600">
                    <input type="checkbox" className="mt-1 accent-red-600" />
                    <span>
                      I would like to receive updates via Email, SMS,
                      WhatsApp, and RCS.
                    </span>
                  </label>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-red-600 to-orange-500 text-white font-semibold py-3 rounded-lg hover:shadow-lg transition-all"
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-xl border border-orange-100 p-6 md:p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Contact Information
              </h3>
              <div className="space-y-4 text-sm text-gray-700">
                <p><strong>Phone:</strong> +91-9839961911</p>
                <p><strong>Email:</strong> info@ashamodernschool.com</p>
                <p><strong>Website:</strong> ashamodernschool.com</p>
                <p>
                  <strong>Address:</strong> Address 2, Mani Nagar, Kandwa Road,
                  Chitaipur, Varanasi
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-xl border border-orange-100 p-6 md:p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Find Our Location
              </h3>
              <div className="w-full h-64 rounded-lg overflow-hidden">
                <iframe
                  title="School Location"
                  src="https://www.google.com/maps?q=Chitaipur%20Varanasi&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ContactSection;